import { Controller } from "@hotwired/stimulus"

// The autonomous-robot illusion: while a Beauftragung is unanswered, the client sees
// the "robot" cycling through planning stages with a progress bar. Pure theatre — a
// human operator is really reading the order. When the operator responds, a Turbo
// Stream swaps this whole fragment out for the reply card, so this controller just
// loops the last stage indefinitely until that happens.
//
// The cycle is anchored to the submission time (the server renders the elapsed
// seconds): a refresh or navigation resumes mid-cycle instead of restarting the
// "processing", which would give the theatre away.
export default class extends Controller {
  static targets = ["stage", "bar"]
  static values = {
    stages: Array,
    elapsed: { type: Number, default: 0 },
    interval: { type: Number, default: 12000 },
  }

  connect() {
    const elapsedMs = this.elapsedValue * 1000
    this.index = Math.min(Math.floor(elapsedMs / this.intervalValue), this.stagesValue.length - 1)
    this.render()
    // First tick lands on the next stage boundary, then the regular cadence.
    this.timeout = setTimeout(
      () => {
        this.advance()
        this.timer = setInterval(() => this.advance(), this.intervalValue)
      },
      this.intervalValue - (elapsedMs % this.intervalValue),
    )
  }

  disconnect() {
    if (this.timeout) clearTimeout(this.timeout)
    if (this.timer) clearInterval(this.timer)
  }

  advance() {
    // Hold on the final stage ("wird ausgeführt…") rather than wrapping around.
    if (this.index < this.stagesValue.length - 1) {
      this.index += 1
      this.render()
    }
  }

  render() {
    const stages = this.stagesValue
    if (this.hasStageTarget && stages.length) {
      this.stageTarget.textContent = stages[this.index]
    }
    if (this.hasBarTarget && stages.length) {
      const pct = Math.round(((this.index + 1) / stages.length) * 100)
      this.barTarget.style.width = `${pct}%`
    }
  }
}
